import { Crossmark, ErrorMessage } from '@talos/kyoko';
import { ErrorBoundaryWrapper, ErrorTitle } from './styles';

export const ErrorBoundaryDisplay = (props: React.PropsWithChildren<{ message?: string; minimal?: boolean }>) => {
  return (
    <ErrorBoundaryWrapper {...props}>
      {!props.minimal && <Crossmark />}
      {props.message || (
        <>
          <ErrorTitle>An unexpected error occurred</ErrorTitle>
          {!props.minimal && (
            <ErrorMessage>
              If this issue persists, please get in touch with support and we will resolve the problem as soon as
              possible.
            </ErrorMessage>
          )}
        </>
      )}
    </ErrorBoundaryWrapper>
  );
};
